import { render, staticRenderFns } from "./VButtonDropdown.vue?vue&type=template&id=a7b1462c&"
import script from "./VButtonDropdown.vue?vue&type=script&lang=ts&"
export * from "./VButtonDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports